import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

class Button extends Component {
    render () {

        let link = '';
        let iconEl = '';
        if ( this.props.icon !== '' ) {
            iconEl = <i className={ `${ this.props.icon }` }></i>;
        }

        if ( this.props.link === '' ) {
            return <span>Please add link to your button!</span>;
        }

        if (this.props.link.indexOf('://') > 0 || this.props.link.indexOf('//') === 0 || this.props.link === '#' ) {
            link = <a href={this.props.link} className={ `button ${ this.props.classes }` } target="_blank">{this.props.title} {iconEl}</a>
        } else {
            link = <NavLink className={ `button ${ this.props.classes }` } to={this.props.link}>{this.props.title} {iconEl}</NavLink>;
        }

        return (
            <span>
            {link}
            </span>
        );
    }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js